var _excluded = ["style"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Div, Svg } from '@kizi/core-components';
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Portal } from 'react-portal';
import { IconV2 as Icon } from './IconV2';
import { capitalise } from '../utils/global';
var ARROW_HEIGHT = 17;
var ARROW_WIDTH = 27;
var VIEWPORT_MARGIN = 10;
var OPPOSITE_POSITIONS = {
  'top': 'bottom',
  'bottom': 'top',
  'left': 'right',
  'right': 'left',
  'top-left': 'bottom-left',
  'top-right': 'bottom-right',
  'bottom-left': 'top-left',
  'bottom-right': 'top-right',
  'left-top': 'right-top',
  'left-bottom': 'right-bottom',
  'right-top': 'left-top',
  'right-bottom': 'left-bottom',
  'left-bottom-down': 'right-bottom-down',
  'right-bottom-down': 'left-bottom-down',
  'left-top-up': 'right-top-up',
  'right-top-up': 'left-top-up',
  'cover': 'cover'
};
var defaultContainerProps = {
  position: 'fixed',
  overflow: 'visible'
};

function combinePositions(mainPosition, secondPosition, targetRect, attachTo) {
  var _attachTo$offsetWidth, _attachTo$offsetHeigh;

  var x = targetRect.x,
      y = targetRect.y,
      _width = targetRect.width,
      _height = targetRect.height;
  var width = (_attachTo$offsetWidth = attachTo.offsetWidth) !== null && _attachTo$offsetWidth !== void 0 ? _attachTo$offsetWidth : _width;
  var height = (_attachTo$offsetHeigh = attachTo.offsetHeight) !== null && _attachTo$offsetHeigh !== void 0 ? _attachTo$offsetHeigh : _height;
  var positions = {};

  if (mainPosition === 'top' || mainPosition === 'bottom') {
    switch (secondPosition) {
      case 'left':
        // should grow right (top-left, bottom-left)
        positions.left = x;
        break;

      case 'right':
        // should grow left (top-right, bottom-right)
        positions.right = window.document.body.clientWidth - (x + width);
        break;

      default:
        // center
        positions.left = x + width / 2;
        positions.transform = 'translateX(-50%)';
        break;
    }
  } else {
    // mainPosition === 'left' | 'right'
    switch (secondPosition) {
      case 'top':
        positions.top = y;
        break;

      case 'top-up':
        positions.bottom = window.innerHeight - y;
        break;

      case 'bottom':
        positions.bottom = window.innerHeight - (y + height);
        break;

      case 'bottom-down':
        positions.top = y + height;
        break;

      default:
        // center
        positions.top = y + height / 2;
        positions.transform = 'translateY(-50%)';
        break;
    }
  }

  return positions;
}

function getHtmlElementSizes(attachTo) {
  var width = attachTo.offsetWidth;
  var height = attachTo.offsetHeight;
  return {
    width: width,
    height: height
  };
}

function getPositions(position) {
  var arrayPosition = position.split('-');
  var mainPosition = arrayPosition[0];
  var secondPosition = arrayPosition.length > 1 ? arrayPosition.slice(1, arrayPosition.length).join('-') : 'center';
  return {
    mainPosition: mainPosition,
    secondPosition: secondPosition
  };
}

function getExtraStyle(attachTo, position) {
  var arrowProps = {};
  var contentProps = {};

  var _getPositions = getPositions(position),
      mainPosition = _getPositions.mainPosition,
      secondPosition = _getPositions.secondPosition;

  var _getHtmlElementSizes = getHtmlElementSizes(attachTo),
      height = _getHtmlElementSizes.height,
      width = _getHtmlElementSizes.width;

  var heightCoeff = height / 2 - ARROW_HEIGHT / 2;
  var widthCoeff = width / 2 - ARROW_WIDTH / 2;
  var contentMargin = 21.5;
  var positions = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
  };
  var positionsValues = {
    top: '5px',
    bottom: '5px',
    left: 0,
    right: 0
  };
  var arrowRotation = {
    top: 180,
    bottom: 0,
    left: 90,
    right: -90
  };

  if (mainPosition in positions) {
    var _arrowProps;

    arrowProps = (_arrowProps = {}, _defineProperty(_arrowProps, positions[mainPosition], positionsValues[mainPosition]), _defineProperty(_arrowProps, "style", {
      transform: "rotate(".concat(arrowRotation[mainPosition], "deg)")
    }), _arrowProps);
    contentProps = _defineProperty({}, "margin".concat(capitalise(positions[mainPosition])), contentMargin);
  }

  var isSecondPositionCenter = secondPosition === 'center';

  if (['left', 'right'].includes(mainPosition)) {
    if (isSecondPositionCenter) {
      contentProps = _objectSpread(_objectSpread({}, contentProps), {}, {
        marginTop: -widthCoeff
      });
    } else {
      arrowProps = _objectSpread(_objectSpread({}, arrowProps), {}, _defineProperty({}, secondPosition, heightCoeff));
    }
  } else {
    if (isSecondPositionCenter) {
      arrowProps = _objectSpread(_objectSpread({}, arrowProps), {}, {
        left: widthCoeff
      });
    } else {
      arrowProps = _objectSpread(_objectSpread({}, arrowProps), {}, _defineProperty({}, secondPosition, widthCoeff));
    }
  }

  if (secondPosition.includes('-')) {
    arrowProps = {
      display: 'none'
    };
  } else {
    arrowProps = _objectSpread(_objectSpread({}, arrowProps), {}, {
      height: ARROW_HEIGHT,
      position: 'absolute',
      width: ARROW_WIDTH
    });
  }

  return {
    arrowProps: arrowProps,
    contentProps: contentProps
  };
}

function wouldFitInViewport(position, attachTo, popoverRef) {
  if (!popoverRef.current) return true;
  var targetRect = attachTo.getBoundingClientRect();

  var _getPositions2 = getPositions(position),
      mainPosition = _getPositions2.mainPosition;

  var popoverRect = popoverRef.current.getBoundingClientRect();
  var popoverWidth = popoverRect.width || 200;
  var popoverHeight = popoverRect.height || 200;
  var viewportWidth = window.innerWidth;
  var viewportHeight = window.innerHeight;

  switch (mainPosition) {
    case 'top':
      return targetRect.top >= popoverHeight + VIEWPORT_MARGIN;

    case 'right':
      return targetRect.left + targetRect.width + popoverWidth + VIEWPORT_MARGIN <= viewportWidth;

    case 'bottom':
      return targetRect.top + targetRect.height + popoverHeight + VIEWPORT_MARGIN <= viewportHeight;

    case 'left':
      return targetRect.left >= popoverWidth + VIEWPORT_MARGIN;

    default:
      return true;
  }
}

function getBestPosition(preferredPosition, attachTo, popoverRef) {
  if (wouldFitInViewport(preferredPosition, attachTo, popoverRef)) {
    return preferredPosition;
  }

  var oppositePosition = OPPOSITE_POSITIONS[preferredPosition];

  if (wouldFitInViewport(oppositePosition, attachTo, popoverRef)) {
    return oppositePosition;
  }

  return preferredPosition;
}

export function getContainerPositions(_ref) {
  var position = _ref.position,
      attachTo = _ref.attachTo,
      popoverRef = _ref.popoverRef;
  var targetRect = attachTo.getBoundingClientRect();
  var x = targetRect.x,
      y = targetRect.y;

  var _getHtmlElementSizes2 = getHtmlElementSizes(attachTo),
      width = _getHtmlElementSizes2.width,
      height = _getHtmlElementSizes2.height;

  var bestPosition = getBestPosition(position, attachTo, popoverRef);
  var positions = {};

  var _getPositions3 = getPositions(bestPosition),
      mainPosition = _getPositions3.mainPosition,
      secondPosition = _getPositions3.secondPosition;

  switch (mainPosition) {
    case 'cover':
      return {
        left: x,
        top: y,
        width: width,
        height: height,
        overflow: 'hidden'
      };

    case 'top':
      positions.bottom = window.innerHeight - y;
      break;

    case 'right':
      positions.left = x + width;
      break;

    case 'bottom':
      positions.top = y + height;
      break;

    case 'left':
      positions.right = window.document.body.clientWidth - x;
      break;
  }

  positions = _objectSpread(_objectSpread({}, positions), combinePositions(mainPosition, secondPosition, targetRect, attachTo));

  if (popoverRef.current) {
    var popoverRect = popoverRef.current.getBoundingClientRect();
    var popoverWidth = popoverRect.width || 300;
    var popoverHeight = popoverRect.height || 200;

    if (positions.left !== undefined) {
      var leftPos = typeof positions.left === 'string' ? parseFloat(positions.left) : positions.left;

      if (leftPos < VIEWPORT_MARGIN) {
        positions.left = VIEWPORT_MARGIN;

        if (positions.transform) {
          positions.transform = positions.transform.toString().replace('translateX(-50%)', '');
        }
      } else if (leftPos + popoverWidth > window.innerWidth - VIEWPORT_MARGIN) {
        if (positions.transform && positions.transform.toString().includes('translateX(-50%)')) {
          positions.left = window.innerWidth - popoverWidth - VIEWPORT_MARGIN;
          positions.transform = positions.transform.toString().replace('translateX(-50%)', '');
        } else {
          positions.left = Math.min(leftPos, window.innerWidth - popoverWidth - VIEWPORT_MARGIN);
        }
      }
    }

    if (positions.top !== undefined) {
      var topPos = typeof positions.top === 'string' ? parseFloat(positions.top) : positions.top;

      if (topPos < VIEWPORT_MARGIN) {
        positions.top = VIEWPORT_MARGIN;

        if (positions.transform) {
          positions.transform = positions.transform.toString().replace('translateY(-50%)', '');
        }
      } else if (topPos + popoverHeight > window.innerHeight - VIEWPORT_MARGIN) {
        if (positions.transform && positions.transform.toString().includes('translateY(-50%)')) {
          positions.top = window.innerHeight - popoverHeight - VIEWPORT_MARGIN;
          positions.transform = positions.transform.toString().replace('translateY(-50%)', '');
        } else {
          // If not using transform
          positions.top = Math.min(topPos, window.innerHeight - popoverHeight - VIEWPORT_MARGIN);
        }
      }
    }
  }

  for (var key in positions) {
    if (Object.prototype.hasOwnProperty.call(positions, key) && typeof positions[key] === 'number') {
      positions[key] = Math.round(positions[key]);
    }
  }

  return positions;
}

function getExtraStyleProps(showContent, arrow, attachTo, position) {
  var arrowProps = {};
  var contentProps = {};

  if (showContent && arrow && attachTo !== null) {
    var extraStyle = getExtraStyle(attachTo, position);
    arrowProps = extraStyle.arrowProps;
    contentProps = extraStyle.contentProps;
  }

  return {
    arrowProps: arrowProps,
    contentProps: contentProps
  };
}

var Popover = /*#__PURE__*/React.forwardRef(function (_ref2, containerRef) {
  var _ref2$arrow = _ref2.arrow,
      arrow = _ref2$arrow === void 0 ? false : _ref2$arrow,
      attachTo = _ref2.attachTo,
      children = _ref2.children,
      onOutsideClick = _ref2.onOutsideClick,
      _ref2$show = _ref2.show,
      show = _ref2$show === void 0 ? false : _ref2$show,
      _ref2$containerProps = _ref2.containerProps,
      containerProps = _ref2$containerProps === void 0 ? {} : _ref2$containerProps,
      _ref2$position = _ref2.position,
      position = _ref2$position === void 0 ? 'bottom' : _ref2$position,
      _ref2$withCloseIcon = _ref2.withCloseIcon,
      withCloseIcon = _ref2$withCloseIcon === void 0 ? true : _ref2$withCloseIcon,
      maxHeight = _ref2.maxHeight;

  var _containerRef = useRef(null);

  var popoverContentRef = useRef(null);

  var _containerProps$style = containerProps.style,
      style = _containerProps$style === void 0 ? {} : _containerProps$style,
      containerPropsWithoutStyle = _objectWithoutProperties(containerProps, _excluded);

  var _containerProps = useMemo(function () {
    return _objectSpread(_objectSpread({}, defaultContainerProps), containerPropsWithoutStyle);
  }, [containerPropsWithoutStyle]);

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      positionProps = _useState2[0],
      setPositionProps = _useState2[1];

  var _useState3 = useState(position),
      _useState4 = _slicedToArray(_useState3, 2),
      actualPosition = _useState4[0],
      setActualPosition = _useState4[1];

  var setPositions = useCallback(function () {
    if (attachTo) {
      var bestPosition = getBestPosition(position, attachTo, _containerRef);
      setActualPosition(bestPosition);
      var positions = getContainerPositions({
        position: bestPosition,
        attachTo: attachTo,
        popoverRef: _containerRef
      });
      setPositionProps(positions);
    }
  }, [attachTo, position]);
  var calculateMaxHeight = useCallback(function () {
    if (!attachTo || !_containerRef.current) return undefined;

    var containerRect = _containerRef.current.getBoundingClientRect();

    var viewportHeight = window.innerHeight;
    if (maxHeight) return maxHeight;

    if ((positionProps === null || positionProps === void 0 ? void 0 : positionProps.top) !== undefined) {
      return "".concat(viewportHeight - containerRect.top - VIEWPORT_MARGIN, "px");
    } else if ((positionProps === null || positionProps === void 0 ? void 0 : positionProps.bottom) !== undefined) {
      return "".concat(viewportHeight - containerRect.bottom - VIEWPORT_MARGIN, "px");
    }

    return undefined;
  }, [attachTo, maxHeight, positionProps]);
  var contentStyle = useMemo(function () {
    var calculatedMaxHeight = calculateMaxHeight();
    return calculatedMaxHeight ? {
      maxHeight: calculatedMaxHeight,
      overflow: 'auto'
    } : {};
  }, [calculateMaxHeight]);
  useLayoutEffect(function () {
    setPositions();
  }, [setPositions, attachTo]);
  useEffect(function () {
    window.addEventListener('resize', setPositions);
    window.addEventListener('scroll', setPositions);
    return function () {
      window.removeEventListener('resize', setPositions);
      window.removeEventListener('scroll', setPositions);
    };
  }, [setPositions]);
  useEffect(function () {
    function handleClickOutside(event) {
      if (onOutsideClick && attachTo && _containerRef.current && !attachTo.contains(event.target) && !_containerRef.current.contains(event.target)) {
        onOutsideClick(event); // Pass the event to the handler
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [attachTo, onOutsideClick]);
  var handleContainerRef = useCallback(function (ref) {
    _containerRef.current = ref;

    if (containerRef) {
      if (typeof containerRef === 'function') {
        containerRef(ref);
      } else {
        containerRef.current = ref;
      }
    }
  }, [containerRef]);
  var showContent = show && attachTo && children;

  var _getExtraStyleProps = getExtraStyleProps(showContent, arrow, attachTo, actualPosition),
      arrowProps = _getExtraStyleProps.arrowProps,
      contentProps = _getExtraStyleProps.contentProps;

  return /*#__PURE__*/React.createElement(React.Fragment, null, showContent && /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Div, _extends({
    display: "grid",
    ref: handleContainerRef
  }, _containerProps, {
    style: _objectSpread(_objectSpread({}, style), positionProps)
  }), arrow && /*#__PURE__*/React.createElement(Svg, _extends({
    filter: "drop-shadow(0px -5px 5px rgba(0, 0, 0, 0.1))",
    viewBox: "0 0 27 17",
    zIndex: 1
  }, arrowProps), /*#__PURE__*/React.createElement("path", {
    d: "M10.1846 1.9125L0 17.0008H27L16.8154 1.9125C15.2295 -0.436976 11.7705 -0.436981 10.1846 1.9125Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement(Div, _extends({
    position: "relative"
  }, contentProps, {
    ref: popoverContentRef,
    style: contentStyle
  }), withCloseIcon && /*#__PURE__*/React.createElement(Icon, {
    fill: "second.0",
    height: 16,
    onClick: function onClick(e) {
      return onOutsideClick && onOutsideClick(e);
    } // Pass the event here too
    ,
    right: [1, 1, 4],
    top: [1, 1, 4],
    name: "cancel",
    position: "absolute",
    style: {
      cursor: 'pointer'
    },
    width: 16
  }), children))));
});
export { Popover };